import {Injectable} from '@angular/core';
import {BaseDaoService, handleError} from '@q9elements/ui-kit/common';
import {GridUtils} from '@q9elements/ui-kit/components';
import {getPluralSingleMap} from '../../util/single-plural-type-map.util';
import {ImpactGridQuery} from '../state/impact-grid.query';
import {StoryLinkService} from './story-link.service';
@Injectable()
export class ImpactGridViewDaoService extends BaseDaoService {
  constructor(
    private storyLinkService: StoryLinkService,
    private query: ImpactGridQuery
  ) {
    super();
  }

  getDependenciesForGrid(refModel, queryParams) {
    const {skip, filters, take} = this.query.getValue();
    const {type, grouping, dependentId, nodes} = queryParams;
    const singlePluralMap = getPluralSingleMap();
    const singleTypeName = singlePluralMap.get(type);
    const builtFilters = GridUtils.parseCompositeFilter(filters);
    const params: any = {
      skip,
      nodes,
      limit: take || 50,
      ...builtFilters
    };

    if (grouping) {
      params.grouping = grouping;
    }

    if (grouping && singleTypeName) {
      params.type = singleTypeName;
    }

    if (grouping && dependentId && !singleTypeName) {
      params.refModelId = dependentId;
    }

    const url = `${this.apiUrl}/refmodel/${refModel._id}/dependency/grid`;

    return this.http.get(url, {params}).pipe(handleError());
  }

  addNodesToStory(requestData) {
    return this.storyLinkService.bulkAddNodesToStory(this.apiUrl, requestData);
  }

  buildFilters(allFilters) {
    if (allFilters) {
      const {filters} = allFilters;
      const filtersToBuild = filters.flat().map(obj => obj.filters[0]);

      return filtersToBuild.reduce((acc, filter: any) => {
        const {field, operator, value} = filter;

        acc[field] = `${operator}_${value}`;

        return acc;
      }, {});
    }

    return {};
  }

  downloadGridViewCsv(refModel, queryParams) {
    const filters = this.query.getValue().filters;
    const {type, grouping, dependentId, nodes} = queryParams;
    const singlePluralMap = getPluralSingleMap();
    const singleTypeName = singlePluralMap.get(type);
    const builtFilters = GridUtils.parseCompositeFilter(filters);
    const params: any = {
      nodes,
      ...builtFilters
    };

    if (grouping) {
      params.grouping = grouping;
    }

    if (grouping && singleTypeName) {
      params.type = singleTypeName;
    }

    if (grouping && dependentId) {
      params.refModelId = dependentId;
    }

    params.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const url = `${this.apiUrl}/refmodel/${refModel._id}/dependency/grid/csv`;

    return this.http.post(url, {params}).pipe(handleError());
  }
}
